/*
 This service is the place where fontAwesome icons are  suggested to be called in a Async way and loaded via the
 fontAwesome API
 more info : https://fontawesome.com/how-to-use/with-the-api/

 methods:
 the configFontAwesome method add aply th configs passed in a dinamyc way,
 applying the properties that the svg-core
 use: https://fontawesome.com/how-to-use/with-the-api/setup/configuration
*/
import AsyncScriptService from 'services/async-script-service';
import utils from 'lib/utils';
import { layer, parse, icon, config as fortawesomeConfig } from '@fortawesome/fontawesome-svg-core';

const IconLoadService = {
  // Basic fontAwesomeApi config
  configFontAwesome: function(properties) {
    for(const key in properties) {
      if(fortawesomeConfig.hasOwnProperty(key)) {
        fortawesomeConfig[key] = properties[key];
      } else {
        console.error(`the property ${key} is not available as a fontAwesomeAPI property check it at \n https://fontawesome.com/how-to-use/with-the-api/setup/configuration`);
      }
    }
  },

  formatIconUrl(iconPrefix, iconName) {
    let camelCasedIcon;
    const iconsType = {
      's': { type: 'solid', folder: 'pro-solid-svg-icons' },
      'r': { type: 'regular', folder: 'pro-regular-svg-icons' },
      'l': { type: 'light', folder: 'pro-light-svg-icons' }
    };

    const prefix = iconPrefix.substring(2);
    if(iconsType.hasOwnProperty(prefix)) {
      camelCasedIcon = _.camelCase(iconName);
      const urlIcon = {
        http: utils.coursePath(`javascripts/fontawesome/${iconsType[prefix].folder}/${camelCasedIcon}.js`),
        require: `@fortawesome/${iconsType[prefix].folder}/${camelCasedIcon}.js`
      };
      return urlIcon;
    } else {
      console.error(`error with ${iconPrefix}, only available properties are Solid(fas), \n regular(far), \n light(fal) \n and brand(fab),`);
    }
  },

  returnIconAsString(iconPrefix, iconName) {
    return new Promise((resolve) => {
      const urlIcon = this.formatIconUrl(iconPrefix, iconName);
      AsyncScriptService.load(urlIcon).then(([iconElem]) => {
        const iconSvg = icon(iconElem.definition);
        resolve(iconSvg.node[0]);
      });
    });
  },

  applyIcon(iconName, iconId, customClasses, optionalPrefix = null) {
    let prefix, name, iconFullName;

    if (optionalPrefix != null) {
      name = iconName;
      prefix = optionalPrefix;

    } else {
      iconFullName = iconName.split(' ');
      [ prefix, name ] =  iconFullName;
    }

    try {
      const urlIcon = this.formatIconUrl(prefix, name);
      AsyncScriptService.load(urlIcon).then(([iconElem]) => {
        let propsIcon = {
          classes: []
        };
        if(customClasses) {
          if(typeof customClasses === 'string') {
            propsIcon.classes.push(customClasses);
          } else if(Array.isArray(customClasses)) {
            customClasses.forEach(element => {
              propsIcon.classes.push(element);
            });
          }
        }
        const iconSvg = icon(iconElem.definition, propsIcon);
        const iconEl = document.querySelector(`[data-icon="${iconId}-${prefix} ${name}"]`);
        if(iconEl) {
          iconEl.appendChild(iconSvg.node[0]);
        }
      })
    } catch(ex) {
      console.error('Icon could not be loaded', ex);
    }
  },

  stackIcons: function(icons, iconId) {
    let iconsUrl = [];
    let iconsClasses = {};
    let iconTransforms = {};
    icons.forEach(elem => {
      iconsUrl.push(this.formatIconUrl(elem.prefix, elem.name));
      if(elem.hasOwnProperty('classes')) {
        iconsClasses[`${elem.prefix}-${elem.name}`] = elem.classes.split(' ');
      }
      if(elem.hasOwnProperty('transforms')) {
        iconTransforms[`${elem.prefix}-${elem.name}`] = parse.transform(elem.transforms);
      }
    });
    AsyncScriptService.load(iconsUrl).then(response => {
      let htmlElem = layer((push) => {
        response.forEach(elem => {
          const classMapper = `${elem.definition.prefix}-fa-${elem.definition.iconName}`;
          const classes = iconsClasses.hasOwnProperty(classMapper) ? iconsClasses[classMapper] : [];
          const transforms = iconTransforms.hasOwnProperty(classMapper) ? iconTransforms[classMapper] : {};
          push(icon(elem.definition, { classes: classes, transform: transforms }));
        });
      });
      try {
        document.getElementById(iconId).appendChild(htmlElem.node[0]);
      } catch(e) {
        console.warn('Could not load icon by id', e);
      }
    });
  }
};

export default IconLoadService;
